import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { TAutoSubmitConfigurationType } from '../../interfaces';

const BASE_URL = `/${SERVICES.LENDER}/lenders/`;

export const requestCreateAutoSubmit = (lenderId: string, autoSubmit: TAutoSubmitConfigurationType) => {
  const path = `${BASE_URL}${lenderId}/autoSubmit`;
  const autoSubmitCreate = {
    active: autoSubmit.active,
    autoSubmitType: autoSubmit.autoSubmit,
    condition: autoSubmit.condition === '' ? 'None' : autoSubmit.condition,
    value: autoSubmit.value?.toString() ?? ''
  };
  return mutate(`${BASE_URL}${lenderId}`, async() => {
    try {
      await axios.put(path, autoSubmitCreate);
      Notistack.successMessage('Auto Submit - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateAutoSubmit = (lenderId: string, autoSubmit: TAutoSubmitConfigurationType) => {
  const path = `${BASE_URL}${lenderId}/autoSubmit/${autoSubmit.id}`;
  const autoSubmitUpdate = {
    active: autoSubmit.active,
    autoSubmitType: autoSubmit.autoSubmit,
    condition: autoSubmit.condition === '' ? 'None' : autoSubmit.condition,
    value: autoSubmit.value === undefined ? '' : autoSubmit.value?.toString(),
  };
  return mutate(`${BASE_URL}${lenderId}`, async() => {
    try {
      await axios.patch(path, autoSubmitUpdate);
      Notistack.successMessage('Auto Submit - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};